import { DoctorRepository } from 'repository/interfaces/doctor-repository'
import { LoadDoctorWithRecommendation } from 'domain/usecases/doctor/load-doctor-with-recommendation'

export class RemoteLoadDoctorWithRecommendation
  implements LoadDoctorWithRecommendation
{
  private readonly doctorRepository: DoctorRepository

  constructor(doctorRepository: DoctorRepository) {
    this.doctorRepository = doctorRepository
  }

  load(
    params: LoadDoctorWithRecommendation.Params
  ): Promise<LoadDoctorWithRecommendation.Model> {
    return this.doctorRepository.loadDoctorWithRecommendation(params)
  }
}
